export default "__VITE_ASSET__DyhZwDRT__"